// Dependencies
import React, { FunctionComponent, useState } from 'react'

// Types
import { AccordionProps } from './accordion.types'

// Styles
import {
  Container,
  AccordionItemWrapper,
  AccordionItemContent,
  AccordionIcon,
  AccordionItemTitleWrapper
} from './accordion.styles'

// Assets
import chevronDown from '../../assets/chevron-down.svg'

export const Accordion: FunctionComponent<AccordionProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const onTitleClick = (index: number) => {
    setActiveIndex(index === activeIndex ? 0 : index)
  }

  const renderedItems = items.map((item, index) => {
    const isActive = index === activeIndex

    return (
      <AccordionItemWrapper
        key={`accordion-item-${index}`}
        isActive={isActive}
        onClick={() => onTitleClick(index)}
      >
        <AccordionItemTitleWrapper>
          <p>{item.title}</p>

          <AccordionIcon
            isActive={isActive}
            src={chevronDown}
            alt="Icone que indica a abertura e o fechamento da seção expansível"
          />
        </AccordionItemTitleWrapper>
        <AccordionItemContent
          isActive={isActive}
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
      </AccordionItemWrapper>
    )
  })

  return <Container>{renderedItems}</Container>
}
